module.exports = __webpack_public_path__ + "img/ru.2451b45f.svg";